export const FilePropertyField = (props: {
  value: string;
  defaultValue: string;
  onChange: (value: string | null) => void;
  openAssets: () => void;
}) => {
  const { value, defaultValue, onChange, openAssets } = props;

  console.log("🍓 file", props);

  return (
    <div className="flex flex-col items-center gap-3">
      {value && value !== defaultValue && (
        <div
          className="w-[50px] h-[50px] rounded inline-block bg-cover bg-center cursor-pointer"
          style={{ backgroundImage: `url("${value}")` }}
          onClick={() => onChange("")}
        />
      )}
      <button type="button" onClick={openAssets}>
        Select Image
      </button>
    </div>

    // inputToRender = (
    //   <FileInput placeholder="Pick file" label="Your resume" withAsterisk />
    // );
  );
};
